import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTransferPricingPeriodSelection, TTransferPricingPolicy } from './types';

export function usePolicyByServiceRequest(
  serviceRequestId: string | null | undefined,
  period?: TTransferPricingPeriodSelection
) {
  const queryString = new URLSearchParams();

  if (serviceRequestId) {
    queryString.append('serviceRequestId', serviceRequestId);
  }

  if (period?.periodType && period?.periodStart) {
    queryString.append('periodType', period.periodType);
    queryString.append('periodStart', period.periodStart);
  }

  const URL = serviceRequestId
    ? `transfer-pricing/policy?${queryString.toString()}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: { policies: TTransferPricingPolicy[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.policies?.[0],
    error,
    mutate,
    isLoading: !data && !error,
  };
}
